module.exports = __webpack_public_path__ + "img/chevron-right-icon.b9540042.svg";